import { createContext, useContext, useState } from "react";
import { requestWithToken } from "../utils/apis";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => Boolean(localStorage.getItem("token"))
  );
  const [user, setUser] = useState({});

  const fetchUserDetails = async (redirectAfterLoad = false) => {
    try {
      const result = await requestWithToken("GET", "/api/user/me");
      if (result?.data?.data) {
        setUser(result.data.data);
        if (redirectAfterLoad) {
          navigate("/pages");
        }
      }
    } catch (err) {
      console.warn("fetchUserDetails:", err?.response?.data?.message || err?.message);
    }
  };

  const login = (redirectAfterLoad = true) => {
    fetchUserDetails(redirectAfterLoad)
    setIsAuthenticated(true)
  };
  const logout = () => {
    setIsAuthenticated(false)
    // localStorage.removeItem("token")
       localStorage.clear();
    sessionStorage.clear();
    
  };


  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
